import { Injectable } from '@angular/core';
import { ApiResponse } from "app/entities";
import { Notification } from 'app/entities/notification';
import { ApiService } from "app/services/api.service";
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends ApiService {

  private notificationUpdatedSource = new Subject<void>();
  notificationUpdated$ = this.notificationUpdatedSource.asObservable();

  private notificationCountUpdatedSource = new Subject<void>();
  notificationCountUpdated$ = this.notificationCountUpdatedSource.asObservable();

  notifyNotificationStatusUpdated() {
    this.notificationUpdatedSource.next();
  }

  notifyNotificationCountUpdated() {
    this.notificationCountUpdatedSource.next();
  }

  private reloadSubject = new Subject<void>();
  reload$ = this.reloadSubject.asObservable();

  triggerReload() {
    this.reloadSubject.next();
  }

  findAll(params: any) {
    params = this.paramsFromObject(params);
    return this.httpService.get(`/v1/admin/notifications`, params)
      .pipe(
        map(res => ApiResponse.parseWith(new Notification, res) as ApiResponse<Notification[]>)
      )
  }

  find(id: any) {
    return this.httpService.get(`/v1/admin/notifications/${id}`)
      .pipe(
        map(res => Notification.parse(res.data) as Notification)
      )
  }

  store(data: any) {
    let formData = this.formDataFromObject(data)
    return this.httpService.post(`/v1/admin/notifications`, formData)
      .pipe(
        map(res => Notification.parse(res.data) as Notification)
      )
  }

  update(id: number, data: any) {
    let formData = this.formDataFromObject(data)
    return this.httpService.post(`/v1/admin/notifications/${id}`, formData)
      .pipe(
        map(res => Notification.parse(res.data) as Notification)
      )
  }

  markAsRead(id: number) {
    return this.httpService.post(`/v1/admin/notifications/${id}/markAsRead`, {});
  }

  destroy(id: number, data: any) {
    return this.httpService.delete(`/v1/admin/notifications/${id}`, data)
  }
}
